import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n from '../i18n/i18n'
//import Home from '../views/Home'
import Files from '../views/Files'
import Profiles from '../views/Profiles'
import Printers from '../views/Printers'
import Dashboard from '../views/Dashboard'
import Search from '../views/Search'
import Download from '../views/Download'
import Account from '../views/Account'
import ReleaseNotes from '../views/ReleaseNotes'
import Color from '@/components/Color'

// test UI route
import UiFIles from '../views/ui/FIles'

Vue.use(VueRouter)

const routes = [

  {
    path: '/ui/files',
    name: 'UiFIles',
    component: UiFIles
  },

  // end

  {
    path: '/files',
    name: 'Files',
    component: Files,
    meta: {
      title: i18n.t('router.files'),
    },
    redirectFrom: ['/myfiles']
  },
  {
    path: '/projects',
    name: 'Projects',
    alias: '/',
    component: Files,
    meta: {
      title: i18n.t('router.projects'),
    }
  },
  {
    path: '/profiles',
    name: 'Profiles',
    component: Profiles,
    meta: {
      title: i18n.t('router.profiles'),
    }
  },
  {
    path: '/printers',
    name: 'Printers',
    component: Printers,
    meta: {
      title: i18n.t('router.printers'),
    },
    redirectFrom: ['/printing']
  },

  {
    path: '/printers/:open',
    name: 'Printers',
    component: Printers,
    meta: {
      title: i18n.t('router.printers'),
    },
    redirectFrom: ['/printing']
  },

  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      title: i18n.t('router.history'),
    },
    redirectFrom: ['/dashboard']
  },
  {
    path: '/search',
    name: 'Search',
    component: Search,
    meta: {
      title: i18n.t('router.search'),
    },
    redirectFrom: ['/search']
  },
  {
    path: '/download/:tab',
    name: 'Download',
    component: Download,
    meta: {
      title: i18n.t('router.download'),
    },
    props: true,
    redirectFrom: ['/download/u3', '/download/makerbot'],
    beforeRedirect: (redirectFrom) => {
      switch (redirectFrom) {
        case '/download/u3': return '/#/download/u3';
        case '/download/makerbot': return '/#/download/makerbot';
        default:return '/#/download'
      }
    }
  },
  {
    path: '/download',
    name: 'Download',
    component: Download,
    meta: {
      title: i18n.t('router.download'),
    },
    redirectFrom: ['/download'],
    beforeRedirect: (redirectFrom, location) => {
      if (location.hash.trim() === '#cloud-plugins') {
        return '/#/download/plugin'
      }
    }
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/account',
    name: 'Account',
    component: Account,
    meta: {
      title: i18n.t('router.account'),
    }
  },
  {
    path: '/color',
    name: 'Color',
    component: Color,
    meta: {
      title: i18n.t('router.color'),
    }
  },
  {
    path: '/release-notes',
    name: 'ReleaseNotes',
    component: ReleaseNotes,
    meta: {
      title: 'Release notes'
    }
  }
]

const router = new VueRouter({
  routes
})

//REDIRECT FROM OLD UI URLs
if (window.location.pathname !== '/') {
  const pathname = window.location.pathname.replace(/\/$/, "");
  for (let i in routes) {
    if (routes[i].redirectFrom !== undefined && routes[i].redirectFrom.indexOf(pathname) >= 0) {
      let href;
      if (routes[i].beforeRedirect) {
        href = routes[i].beforeRedirect(pathname, window.location);
      }
      if (!href) {
        href = '/#' + routes[i].path;
        if (window.location.hash && window.location.hash.indexOf('?') >= 0) {
          href += window.location.hash.substr(window.location.hash.indexOf('?'));
        } else if (window.location.search) {
          href += window.location.search;
        }
      }
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '3DPrinterOS', href);
      } else {
        router.push(href.substr(2));
      }
      break;
    }
  }
}

router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  document.title = 'Diaprint' + (nearestWithTitle ? ' - '+nearestWithTitle.meta.title : '');

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) {
    return next();
  }

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
    // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag));

  next();
});

export default router
